const defaultGroupState = () => {
    return {
        group: {},
        groups: [],
        groupUsers: [],
        selectedBuyers: [],
        selectedProviders: [],
        selectedSponsors: [],
        groupsPagination: [],
        providersByGroup: [],
    }
}
export default {
    namespaced: true,
    state: defaultGroupState(),
    mutations: {
        setGroup(state, group) {
            Object.assign(state, { group });
        },
        setGroups(state, groups) {
            Object.assign(state, { groups });
        },
        setGroupUsers(state, groupUsers) {
            Object.assign(state, { groupUsers });
        },
        setSelectedBuyers(state, selectedBuyers) {
            Object.assign(state, { selectedBuyers });
        },
        setSelectedProviders(state, selectedProviders) {
            Object.assign(state, { selectedProviders });
        },
        setSelectedSponsors(state, selectedSponsors) {
            Object.assign(state, { selectedSponsors });
        },
        setGroupsPagination(state, groupsPagination) {
            Object.assign(state, { groupsPagination });
        },
        resetState(state) {
            Object.assign(state, defaultGroupState())
        },
        setProvidersByGroup(state, providersByGroup) {
            Object.assign(state, { providersByGroup });
        },
    },
    actions: {}
}